// extracted by mini-css-extract-plugin
export var actionButton = "_qv-0";
export var actionMenuContainer = "_qv-i";
export var bubble = "_qv-2";
export var bubbleActionMenu = "_qv-j";
export var bubbleContext = "_qv-6";
export var bubbleItems = "_qv-7";
export var customer = "_qv-3";
export var divider = "_qv-8";
export var fileList = "_qv-9";
export var hiddenComment = "_qv-o";
export var infoAbove = "_qv-a";
export var internal = "_qv-4";
export var lightActionButton = "_qv-1";
export var link = "_qv-b";
export var merchant = "_qv-5";
export var message = "_qv-c";
export var profilePicture = "_qv-e";
export var quillToolbarContainer = "_qv-f";
export var senderDate = "_qv-g";
export var senderDateCustomer = "_qv-h";
export var senderName = "_qv-d";
export var time = "_qv-k";
export var uploadedImage = "_qv-l";
export var username = "_qv-m";
export var xsmall = "_qv-n";